import type {ReactElement} from 'react';
import React from 'react';
import type {IconStates} from '@Components/contextual-menu/components/styling-options';
import { StylingOptions} from '@Components/contextual-menu/components/styling-options';
import {Option} from '@Components/contextual-menu/components/option';

interface ContextualMenuStylingOptionProps {
  id: string;
  className?: string;
  label: string;
  data: Array<IconStates>;

  containerHasOverflow?: boolean;

  onClick?(id?: string, icon?: string): void;
}

export function ContextualMenuStylingOption({className = '', containerHasOverflow = false, ...props}: ContextualMenuStylingOptionProps): ReactElement<any> | null {
  return (
    <Option
      key={props.id}
      className={className}
      label={props.label}
      subOptionHasOverflow={containerHasOverflow}
      optionControl={
        <StylingOptions
          icons={props.data}
          onClick={(id, icon): void => {
            if (props.onClick) {
              props.onClick(id, icon);
            }
          }}
        />
      }
    />
  );
}
